import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/website/overview')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$orgId/website',
      params: { orgId: params.orgId },
      replace: true,
    })
  },
})
